import { useQuery } from '@tanstack/react-query';
import { documentsApi } from '../api';

export const useDocumentStats = () => {
  return useQuery({
    queryKey: ['documents', 'stats'],
    queryFn: () => documentsApi.getStats(),
  });
};
